// extracted by mini-css-extract-plugin
export default {"donut":"donutProgress_donut__blI4s","box":"donutProgress_box__rpGBN","inner-box":"donutProgress_inner-box__97BU0"};